export default {"src":"/_next/static/media/Group-25845.ec1397ad.svg","height":104,"width":104};